var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurityAndInfra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 166.97 159.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#f0f0f0;}.cls-4{fill:#e0e0e0;}.cls-5{stroke:#27debf;stroke-miterlimit:10;}.cls-6{fill:#37474f;}.cls-7{fill:#263238;}.cls-8{fill:#455a64;}.cls-9{fill:#27debf;}.cls-10{fill:#fafafa;}.cls-11{fill:#f5f5f5;}.cls-12{fill:#ebebeb;}.cls-13{fill:#fff;}.cls-14{fill:#ffa8a7;}.cls-15{opacity:0.1;}.cls-16{clip-path:url(#clip-path-7);}.cls-17{fill:#f28f8f;}.cls-18{clip-path:url(#clip-path-8);}.cls-19{opacity:0.4;}.cls-20{clip-path:url(#clip-path-9);}.cls-21{opacity:0.2;}.cls-22{clip-path:url(#clip-path-10);}.cls-23{fill:#e6e6e6;}.cls-24{clip-path:url(#clip-path-11);}.cls-25{fill:url(#linear-gradient);}.cls-26{opacity:0.61;}.cls-27{clip-path:url(#clip-path-13);}.cls-28{clip-path:url(#clip-path-14);}.cls-29{clip-path:url(#clip-path-15);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 166.97,
    height: 159.19
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.29,
    y: 112.4,
    width: 26.95,
    height: 8.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.94,
    y: 93.69,
    width: 11.96,
    height: 21.99
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.44,
    y: 93.09,
    width: 13.64,
    height: 7.29
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 142.52,
    y: 93.69,
    width: 11.55,
    height: 7.69
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.34,37.89c-4.83,5-12.23,6.86-16.2,6.5a1.32,1.32,0,0,0-1.42,1.19v.15c.25,11-.53,25.8,17.76,37.19a1.29,1.29,0,0,0,1.25.07C74.4,81.26,92.1,71.41,89.29,44.22a1.32,1.32,0,0,0-1.23-1.17c-3.09-.17-12-1-17.39-5a1.46,1.46,0,0,0-.86-.32.65.65,0,0,0-.47.18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -15.66,
    y1: 169.31,
    x2: -15.65,
    y2: 169.31,
    gradientTransform: "matrix(146.88, 0, 0, -147.05, 2299.74, 24957.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5908c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df6f63"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.68,
    y: 40.07,
    width: 33.96,
    height: 40.95
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 63.96,
    y: 47.28,
    width: 13.42,
    height: 7.72
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.12,
    y: 55.67,
    width: 17.09,
    height: 13.84
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    className: "cls-3",
    d: "M24.45,146.14c32.6,17.4,85.46,17.4,118.06,0s32.61-45.62,0-63-85.46-17.4-118.06,0-32.6,45.61,0,63",
    transform: "translate(0 0)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    className: "cls-4",
    d: "M82.45,122.68l23.83,13.7a1.08,1.08,0,0,0,1,0L149.45,112a.31.31,0,0,0,.19-.38.3.3,0,0,0-.19-.19l-23.83-13.7a1.08,1.08,0,0,0-1,0L82.45,122.1a.31.31,0,0,0,0,.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    className: "cls-4",
    d: "M155.24,129.79c-.08-.61-.81-.92-1.21-1.15l-16.27-9.42a2.34,2.34,0,0,0-2.33,0l-16.27,9.38c-.48.28-1.26.81-1.26,1.43s.43.75,1.22,1.21l16.15,9.33a2.69,2.69,0,0,0,2.66,0L154.59,131a1.25,1.25,0,0,0,.65-1.21",
    transform: "translate(0 0)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    className: "cls-5",
    d: "M99.7,81.52l3.83-2.22a1.86,1.86,0,0,1,1.66,0l24.06,13.89",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    className: "cls-5",
    d: "M98.14,80.62l5.39-3.12a1.86,1.86,0,0,1,1.66,0l25.62,14.79",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    className: "cls-5",
    d: "M132.36,91.4,105.19,75.71a1.8,1.8,0,0,0-1.66,0l-6.94,4",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    className: "cls-5",
    d: "M133.92,90.5,105.19,73.91a1.86,1.86,0,0,0-1.66,0L95,78.82",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    className: "cls-6",
    d: "M75.53.27,50.74,14.58A1.84,1.84,0,0,0,49.91,16V84.16a1.82,1.82,0,0,0,.83,1.43L75.53,99.9a1.8,1.8,0,0,0,1.66,0L102,85.59a1.82,1.82,0,0,0,.83-1.43V16a1.84,1.84,0,0,0-.83-1.44L77.19.27a1.86,1.86,0,0,0-1.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    className: "cls-7",
    d: "M102.8,16V84.16a1.82,1.82,0,0,1-.83,1.43L77.19,99.9a1.62,1.62,0,0,1-.83.2v-70a1.72,1.72,0,0,0,.83-.2L102,15.54l.23-.19.3-.24a1.73,1.73,0,0,1,.3.91",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    className: "cls-8",
    d: "M53.85,22.73,72.42,33.44a1.84,1.84,0,0,1,.83,1.44V42c0,.52-.37.74-.83.47L53.85,31.71A1.87,1.87,0,0,1,53,30.27V23.21c0-.53.38-.75.83-.48",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    className: "cls-9",
    d: "M54.58,25.84a1.79,1.79,0,0,0,.83,1.38l15.45,8.92c.46.26.83.07.83-.42a1.77,1.77,0,0,0-.83-1.38L55.41,25.42c-.46-.26-.83-.08-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    className: "cls-7",
    d: "M54.58,29.43a1.77,1.77,0,0,0,.83,1.38l15.45,8.92c.46.27.83.08.83-.42a1.79,1.79,0,0,0-.83-1.38L55.41,29c-.46-.26-.83-.07-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    className: "cls-9",
    d: "M55.41,29l8.5,4.91v1.8l-8.5-4.91a1.77,1.77,0,0,1-.83-1.38c0-.49.37-.68.83-.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    className: "cls-8",
    d: "M53.85,35.3,72.42,46a1.82,1.82,0,0,1,.83,1.43v7.07c0,.53-.37.74-.83.48L53.85,44.28A1.85,1.85,0,0,1,53,42.84V35.78c0-.53.38-.74.83-.48",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    className: "cls-9",
    d: "M54.58,38.41a1.77,1.77,0,0,0,.83,1.38l15.45,8.92c.46.27.83.08.83-.42a1.77,1.77,0,0,0-.83-1.37L55.41,38c-.46-.26-.83-.07-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    className: "cls-7",
    d: "M54.58,42a1.77,1.77,0,0,0,.83,1.37L70.86,52.3c.46.27.83.08.83-.42a1.77,1.77,0,0,0-.83-1.37L55.41,41.59c-.46-.27-.83-.08-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    className: "cls-9",
    d: "M55.41,41.59l13.17,7.6V51L55.41,43.38A1.77,1.77,0,0,1,54.58,42c0-.5.37-.69.83-.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    className: "cls-8",
    d: "M53.85,47.87,72.42,58.59A1.83,1.83,0,0,1,73.25,60v7.06c0,.53-.37.75-.83.48L53.85,56.86A1.87,1.87,0,0,1,53,55.42V48.35c0-.52.38-.74.83-.47",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    className: "cls-9",
    d: "M54.58,51a1.77,1.77,0,0,0,.83,1.37l15.45,8.93c.46.26.83.07.83-.42a1.77,1.77,0,0,0-.83-1.38L55.41,50.57c-.46-.27-.83-.08-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    className: "cls-7",
    d: "M54.58,54.58A1.79,1.79,0,0,0,55.41,56l15.45,8.92c.46.26.83.07.83-.42a1.77,1.77,0,0,0-.83-1.38L55.41,54.16c-.46-.27-.83-.08-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    className: "cls-9",
    d: "M55.41,54.16l5.39,3.11v1.8L55.41,56a1.77,1.77,0,0,1-.83-1.37c0-.5.37-.69.83-.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    className: "cls-8",
    d: "M53.85,60.45,72.42,71.16a1.84,1.84,0,0,1,.83,1.44v7.07c0,.52-.37.74-.83.48L53.85,69.43A1.87,1.87,0,0,1,53,68V60.93c0-.53.38-.75.83-.48",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    className: "cls-9",
    d: "M54.58,63.56a1.79,1.79,0,0,0,.83,1.38l15.45,8.92c.46.26.83.08.83-.42a1.77,1.77,0,0,0-.83-1.38L55.41,63.14c-.46-.26-.83-.08-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    className: "cls-7",
    d: "M54.58,67.15a1.77,1.77,0,0,0,.83,1.38l15.45,8.92c.46.27.83.08.83-.42a1.8,1.8,0,0,0-.83-1.38L55.41,66.73c-.46-.26-.83-.07-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    className: "cls-9",
    d: "M55.41,66.73l8.5,4.91v1.8l-8.5-4.91a1.77,1.77,0,0,1-.83-1.38c0-.49.37-.68.83-.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    className: "cls-8",
    d: "M53.85,73,72.42,83.74a1.82,1.82,0,0,1,.83,1.43v7.07c0,.53-.37.74-.83.48L53.85,82A1.85,1.85,0,0,1,53,80.56V73.5c0-.53.38-.74.83-.48",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    className: "cls-9",
    d: "M54.58,76.13a1.77,1.77,0,0,0,.83,1.38l15.45,8.92c.46.27.83.08.83-.42a1.77,1.77,0,0,0-.83-1.37L55.41,75.71c-.46-.26-.83-.07-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    className: "cls-7",
    d: "M54.58,79.73a1.77,1.77,0,0,0,.83,1.37L70.86,90c.46.27.83.08.83-.41a1.77,1.77,0,0,0-.83-1.38L55.41,79.31c-.46-.27-.83-.08-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    className: "cls-9",
    d: "M55.41,79.31,67,86v1.8L55.41,81.1a1.77,1.77,0,0,1-.83-1.37c0-.5.37-.69.83-.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    className: "cls-6",
    d: "M80.25,34.38c.86-.5,1.55-.05,1.55,1V76.47a3.55,3.55,0,0,1-1.55,2.81c-.86.5-1.56,0-1.56-1V37.19a3.54,3.54,0,0,1,1.56-2.81",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    className: "cls-7",
    d: "M80.25,78.37A1.75,1.75,0,0,0,81,77V35.77c0-.52-.34-.75-.77-.5a1.76,1.76,0,0,0-.78,1.4v41.2c0,.52.35.75.78.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    className: "cls-9",
    d: "M80.25,78.38A1.78,1.78,0,0,0,81,77V57.27l-1.55.9v19.7c0,.52.35.75.78.5",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    className: "cls-6",
    d: "M84.91,31.68c.86-.5,1.56,0,1.56,1V73.77a3.56,3.56,0,0,1-1.56,2.82c-.86.5-1.55,0-1.55-1V34.5a3.59,3.59,0,0,1,1.55-2.82",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    className: "cls-9",
    d: "M84.91,75.68a1.78,1.78,0,0,0,.78-1.41V33.08c0-.53-.35-.76-.78-.51A1.8,1.8,0,0,0,84.14,34V75.17c0,.53.34.76.77.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    className: "cls-6",
    d: "M89.58,29c.86-.5,1.55,0,1.55,1V71.08a3.56,3.56,0,0,1-1.55,2.82c-.86.5-1.56,0-1.56-1V31.8A3.58,3.58,0,0,1,89.58,29",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    className: "cls-7",
    d: "M89.58,73a1.78,1.78,0,0,0,.78-1.41V30.39c0-.53-.35-.76-.78-.51a1.77,1.77,0,0,0-.78,1.4v41.2c0,.53.35.75.78.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    className: "cls-9",
    d: "M89.58,73a1.78,1.78,0,0,0,.78-1.41V39.76l-1.56.9V72.48c0,.53.35.76.78.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    className: "cls-6",
    d: "M94.25,26.29c.86-.5,1.55,0,1.55,1V68.39a3.57,3.57,0,0,1-1.55,2.81c-.86.5-1.56,0-1.56-1V29.11a3.57,3.57,0,0,1,1.56-2.82",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    className: "cls-7",
    d: "M94.25,70.29a1.8,1.8,0,0,0,.78-1.4V27.69c0-.53-.35-.75-.78-.51a1.78,1.78,0,0,0-.78,1.41V69.78c0,.53.35.76.78.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    className: "cls-9",
    d: "M94.25,70.29a1.8,1.8,0,0,0,.78-1.4v-7l-1.56.9v7c0,.53.35.76.78.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    className: "cls-6",
    d: "M98.91,23.6c.86-.5,1.56-.05,1.56,1V65.69a3.57,3.57,0,0,1-1.56,2.82c-.86.5-1.55,0-1.55-1V26.42a3.57,3.57,0,0,1,1.55-2.82",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    className: "cls-7",
    d: "M98.91,67.6a1.78,1.78,0,0,0,.78-1.41V25c0-.53-.35-.76-.78-.51a1.8,1.8,0,0,0-.77,1.41V67.09c0,.53.34.76.77.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    className: "cls-9",
    d: "M98.91,67.6a1.78,1.78,0,0,0,.78-1.41V44.7l-1.55.9V67.09c0,.53.34.76.77.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    className: "cls-6",
    d: "M79.35,84.28,99.8,72.48c.37-.22.67,0,.67.38v7.45a1.48,1.48,0,0,1-.67,1.15L79.35,93.26c-.36.22-.66,0-.66-.38V85.43a1.48,1.48,0,0,1,.66-1.15",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    className: "cls-7",
    d: "M80.2,86.49c0,.5.37.69.83.42L98.14,77A1.77,1.77,0,0,0,99,75.65c0-.49-.37-.68-.83-.42L81,85.11a1.8,1.8,0,0,0-.83,1.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    className: "cls-9",
    d: "M80.2,86.49c0,.5.37.69.82.42l12.45-7.19V77.93L81,85.12a1.8,1.8,0,0,0-.83,1.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    className: "cls-7",
    d: "M80.2,90.08c0,.5.37.69.83.42l17.11-9.88A1.77,1.77,0,0,0,99,79.24c0-.49-.37-.68-.83-.41L81,88.71a1.77,1.77,0,0,0-.83,1.37",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    className: "cls-9",
    d: "M80.2,90.08c0,.5.37.69.83.42l4.66-2.69V86L81,88.71a1.77,1.77,0,0,0-.83,1.37",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    className: "cls-8",
    d: "M102,14.58,77.19.27a1.86,1.86,0,0,0-1.66,0L50.74,14.58a.51.51,0,0,0-.31.64.49.49,0,0,0,.31.32L75.53,29.85a1.86,1.86,0,0,0,1.66,0L102,15.54a.5.5,0,0,0,.32-.64.51.51,0,0,0-.32-.32",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    className: "cls-7",
    d: "M75.86,26.45,56.63,15.35a1.11,1.11,0,0,1-.5-.86v-.65a1.11,1.11,0,0,1,.5-.86L75.86,1.88a1.1,1.1,0,0,1,1,0L96.08,13a1.08,1.08,0,0,1,.5.86v.65a1.08,1.08,0,0,1-.5.86L76.85,26.45a1.08,1.08,0,0,1-1,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    className: "cls-8",
    d: "M56.63,13.55l19.23,11.1a1.08,1.08,0,0,0,1,0l19.23-11.1a.29.29,0,0,0,.19-.38.3.3,0,0,0-.19-.19L76.86,2.26a1.1,1.1,0,0,0-1,0L56.63,13a.3.3,0,0,0,0,.57",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    className: "cls-6",
    d: "M76.36,24.77v1.8a1.06,1.06,0,0,1-.5-.12L56.63,15.35a1.11,1.11,0,0,1-.5-.86v-.65a1.14,1.14,0,0,1,.41-.8c-.18.16-.15.37.09.51l19.23,11.1a.86.86,0,0,0,.5.12",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    className: "cls-7",
    d: "M75.86,21.06l-13-7.51a1.08,1.08,0,0,1-.5-.86V12a1.08,1.08,0,0,1,.5-.86l8.33-4.81A3.17,3.17,0,0,0,72,5.62L76,.26a.66.66,0,0,1,.84-.18l13,7.51a1.11,1.11,0,0,1,.5.86v4.24a1.11,1.11,0,0,1-.5.86l-13,7.51a1.1,1.1,0,0,1-1,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    className: "cls-8",
    d: "M76.85,19.27l8.34-4.82A2.94,2.94,0,0,0,86,13.7l4-5.36a.5.5,0,0,0-.09-.7.18.18,0,0,0-.07,0L76.86.08A.66.66,0,0,0,76,.26L72,5.62a3.17,3.17,0,0,1-.77.78l-8.4,4.78a.31.31,0,0,0-.2.38.36.36,0,0,0,.2.2l13,7.5a1.1,1.1,0,0,0,1,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    className: "cls-6",
    d: "M89.86,7.59,76.86.08A.66.66,0,0,0,76,.26L72,5.62a2.28,2.28,0,0,1-.4.42l14,8.09a2.72,2.72,0,0,0,.4-.43l4-5.36a.5.5,0,0,0-.09-.7.18.18,0,0,0-.07,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    className: "cls-9",
    d: "M66,11.31a1.34,1.34,0,0,1,1.17,0,.37.37,0,0,1,.22.45.39.39,0,0,1-.22.23A1.33,1.33,0,0,1,66,12a.35.35,0,0,1-.22-.45.36.36,0,0,1,.22-.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    className: "cls-9",
    d: "M68.34,12.66a1.33,1.33,0,0,1,1.17,0,.35.35,0,0,1,.22.45.34.34,0,0,1-.22.23,1.34,1.34,0,0,1-1.17,0,.37.37,0,0,1-.22-.46.4.4,0,0,1,.22-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    className: "cls-7",
    d: "M70.68,14a1.25,1.25,0,0,1,1.16,0,.35.35,0,0,1,.23.45.36.36,0,0,1-.23.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.36.36,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    className: "cls-7",
    d: "M73,15.36a1.27,1.27,0,0,1,1.17,0,.36.36,0,0,1,.22.45.4.4,0,0,1-.22.22A1.27,1.27,0,0,1,73,16a.34.34,0,0,1-.22-.45.31.31,0,0,1,.22-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    className: "cls-9",
    d: "M67.76,10.3a1.34,1.34,0,0,1,1.17,0,.37.37,0,0,1,.22.45.36.36,0,0,1-.22.23,1.34,1.34,0,0,1-1.17,0,.35.35,0,0,1-.22-.45.36.36,0,0,1,.22-.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    className: "cls-7",
    d: "M70.09,11.65a1.33,1.33,0,0,1,1.17,0,.35.35,0,0,1,.22.45.34.34,0,0,1-.22.23,1.34,1.34,0,0,1-1.17,0,.37.37,0,0,1-.22-.45.39.39,0,0,1,.22-.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    className: "cls-9",
    d: "M72.43,13a1.25,1.25,0,0,1,1.16,0,.35.35,0,0,1,.23.45.36.36,0,0,1-.23.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.36.36,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    className: "cls-7",
    d: "M74.76,14.35a1.27,1.27,0,0,1,1.17,0,.36.36,0,0,1,.22.45.37.37,0,0,1-.22.22,1.27,1.27,0,0,1-1.17,0,.34.34,0,0,1-.22-.45.31.31,0,0,1,.22-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    className: "cls-7",
    d: "M69.51,9.29a1.34,1.34,0,0,1,1.17,0,.37.37,0,0,1,.22.45.36.36,0,0,1-.22.23,1.34,1.34,0,0,1-1.17,0,.35.35,0,0,1-.22-.45.34.34,0,0,1,.22-.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    className: "cls-9",
    d: "M71.84,10.64a1.27,1.27,0,0,1,1.17,0,.35.35,0,0,1,.22.45.32.32,0,0,1-.22.22,1.27,1.27,0,0,1-1.17,0,.36.36,0,0,1-.22-.45.4.4,0,0,1,.22-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    className: "cls-7",
    d: "M74.18,12a1.25,1.25,0,0,1,1.16,0,.35.35,0,0,1,.23.45.36.36,0,0,1-.23.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.36.36,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    className: "cls-9",
    d: "M75.36,16.68a1.25,1.25,0,0,1,1.16,0,.35.35,0,0,1,.23.45.39.39,0,0,1-.23.22,1.25,1.25,0,0,1-1.16,0,.36.36,0,0,1-.23-.45.34.34,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    className: "cls-7",
    d: "M77.11,15.67a1.25,1.25,0,0,1,1.16,0,.35.35,0,0,1,.23.45.39.39,0,0,1-.23.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.34.34,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    className: "cls-7",
    d: "M76.51,13.34a1.27,1.27,0,0,1,1.17,0,.36.36,0,0,1,.22.45.37.37,0,0,1-.22.22,1.27,1.27,0,0,1-1.17,0,.34.34,0,0,1-.22-.45.32.32,0,0,1,.22-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    className: "cls-9",
    d: "M71.26,8.28a1.34,1.34,0,0,1,1.17,0,.37.37,0,0,1,.22.45.36.36,0,0,1-.22.23,1.34,1.34,0,0,1-1.17,0A.35.35,0,0,1,71,8.51a.36.36,0,0,1,.22-.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    className: "cls-7",
    d: "M73.59,9.63a1.33,1.33,0,0,1,1.17,0,.35.35,0,0,1,.22.45.34.34,0,0,1-.22.23,1.34,1.34,0,0,1-1.17,0,.37.37,0,0,1-.22-.45.39.39,0,0,1,.22-.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    className: "cls-9",
    d: "M75.93,11a1.25,1.25,0,0,1,1.16,0,.35.35,0,0,1,.23.45.36.36,0,0,1-.23.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.36.36,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    className: "cls-7",
    d: "M78.26,12.33a1.27,1.27,0,0,1,1.17,0,.36.36,0,0,1,.22.45.4.4,0,0,1-.22.22,1.27,1.27,0,0,1-1.17,0,.34.34,0,0,1-.22-.45.31.31,0,0,1,.22-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    className: "cls-9",
    d: "M78.86,14.66a1.25,1.25,0,0,1,1.16,0,.35.35,0,0,1,.23.45.39.39,0,0,1-.23.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.34.34,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    className: "cls-7",
    d: "M80.61,13.65a1.25,1.25,0,0,1,1.16,0,.35.35,0,0,1,.23.45.39.39,0,0,1-.23.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.34.34,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    className: "cls-6",
    d: "M76.39,19.38v1.8a1,1,0,0,1-.53-.12l-13-7.51a1.08,1.08,0,0,1-.5-.86V12a1.06,1.06,0,0,1,.4-.79c-.18.15-.15.37.1.51l13,7.51a1,1,0,0,0,.52.11",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    className: "cls-7",
    d: "M73.75,5.4v0a.45.45,0,0,1,.56-.12L85.64,11.8a.34.34,0,0,1,.14.45l0,.05h0a.45.45,0,0,1-.56.12L73.86,5.9a.33.33,0,0,1-.14-.45l0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    className: "cls-9",
    d: "M73.75,5.4v0a.45.45,0,0,1,.56-.12l8.42,4.86-.47.63L73.86,5.9a.33.33,0,0,1-.14-.45l0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    className: "cls-7",
    d: "M74.69,4.14v0A.43.43,0,0,1,75.26,4l11.32,6.53a.33.33,0,0,1,.13.45l0,0v0a.43.43,0,0,1-.56.11L74.79,4.64a.33.33,0,0,1-.13-.45l0-.05",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    className: "cls-9",
    d: "M74.69,4.14v0A.43.43,0,0,1,75.26,4l2.81,1.62-.47.63L74.79,4.64a.33.33,0,0,1-.13-.45l0-.05",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    className: "cls-7",
    d: "M75.62,2.89l0,0a.45.45,0,0,1,.56-.12L87.51,9.29a.34.34,0,0,1,.14.45l0,0h0a.45.45,0,0,1-.56.12L75.73,3.39a.34.34,0,0,1-.14-.45l0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    className: "cls-9",
    d: "M75.62,2.89l0,0a.45.45,0,0,1,.56-.12l5.89,3.39-.47.64L75.73,3.39a.34.34,0,0,1-.14-.45l0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    className: "cls-7",
    d: "M76.56,1.63v0a.43.43,0,0,1,.56-.11L88.45,8a.33.33,0,0,1,.13.45l0,0v0a.43.43,0,0,1-.56.11L76.66,2.13a.33.33,0,0,1-.13-.45l0-.05",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    className: "cls-9",
    d: "M76.56,1.63v0a.43.43,0,0,1,.56-.11L87.41,7.43l-.47.63L76.66,2.13a.33.33,0,0,1-.13-.45l0-.05",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    className: "cls-5",
    d: "M56.14,106.66,60,104.45a1.86,1.86,0,0,1,1.66,0l22.8,13.16a.85.85,0,0,0,1.15-.31.88.88,0,0,0,.11-.42V98",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    className: "cls-5",
    d: "M54.58,105.77,60,102.65a1.86,1.86,0,0,1,1.66,0L86,116.71a.84.84,0,0,0,1.15-.31.79.79,0,0,0,.12-.42V98",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    className: "cls-5",
    d: "M53,104.87l6.95-4a1.8,1.8,0,0,1,1.66,0l25.91,15a.83.83,0,0,0,1.15-.31.76.76,0,0,0,.11-.42v-17",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    className: "cls-5",
    d: "M51.46,104,60,99.06a1.86,1.86,0,0,1,1.66,0l27.46,15.86a.84.84,0,0,0,1.15-.31.82.82,0,0,0,.12-.43V98.13",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    className: "cls-6",
    d: "M30.42,26.31,5.63,40.62a1.84,1.84,0,0,0-.83,1.44V110.2a1.81,1.81,0,0,0,.83,1.43l24.79,14.31a1.8,1.8,0,0,0,1.66,0l24.78-14.31a1.81,1.81,0,0,0,.83-1.43V42.06a1.84,1.84,0,0,0-.83-1.44L32.08,26.31a1.86,1.86,0,0,0-1.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    className: "cls-7",
    d: "M57.69,42.06V110.2a1.82,1.82,0,0,1-.83,1.43L32.07,125.94a1.56,1.56,0,0,1-.82.2v-70a1.66,1.66,0,0,0,.82-.2L56.86,41.58l.23-.19.29-.24a1.66,1.66,0,0,1,.31.91",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    className: "cls-8",
    d: "M8.74,48.77,27.31,59.48a1.87,1.87,0,0,1,.83,1.44V68c0,.53-.38.74-.83.48L8.74,57.75a1.83,1.83,0,0,1-.83-1.44V49.25c0-.53.37-.75.83-.48",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    className: "cls-9",
    d: "M9.47,51.88a1.79,1.79,0,0,0,.83,1.38l15.45,8.92c.46.26.83.08.83-.42a1.77,1.77,0,0,0-.83-1.38L10.3,51.46c-.46-.26-.83-.08-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    className: "cls-7",
    d: "M9.47,55.47a1.77,1.77,0,0,0,.83,1.38l15.45,8.92c.46.27.83.08.83-.42A1.8,1.8,0,0,0,25.75,64L10.3,55.05c-.46-.26-.83-.07-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    className: "cls-9",
    d: "M10.3,55.05,18.8,60v1.8l-8.5-4.91a1.77,1.77,0,0,1-.83-1.38c0-.49.37-.68.83-.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    className: "cls-8",
    d: "M8.74,61.34,27.31,72.06a1.85,1.85,0,0,1,.83,1.43v7.07c0,.53-.38.74-.83.48L8.74,70.32a1.82,1.82,0,0,1-.83-1.43V61.82c0-.53.37-.74.83-.48",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    className: "cls-9",
    d: "M9.47,64.45a1.77,1.77,0,0,0,.83,1.38l15.45,8.92c.46.27.83.08.83-.42A1.77,1.77,0,0,0,25.75,73L10.3,64c-.46-.26-.83-.07-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    className: "cls-7",
    d: "M9.47,68.05a1.77,1.77,0,0,0,.83,1.37l15.45,8.93c.46.26.83.07.83-.42a1.77,1.77,0,0,0-.83-1.38L10.3,67.63c-.46-.27-.83-.08-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    className: "cls-9",
    d: "M10.3,67.63l13.17,7.6V77L10.3,69.42a1.77,1.77,0,0,1-.83-1.37c0-.5.37-.69.83-.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    className: "cls-8",
    d: "M8.74,73.91,27.31,84.63a1.85,1.85,0,0,1,.83,1.44v7.06c0,.53-.38.75-.83.48L8.74,82.9a1.84,1.84,0,0,1-.83-1.44V74.39c0-.52.37-.74.83-.47",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    className: "cls-9",
    d: "M9.47,77a1.77,1.77,0,0,0,.83,1.37l15.45,8.93c.46.26.83.07.83-.42a1.77,1.77,0,0,0-.83-1.38L10.3,76.61c-.46-.27-.83-.08-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    className: "cls-7",
    d: "M9.47,80.62A1.79,1.79,0,0,0,10.3,82l15.45,8.92c.46.26.83.07.83-.42a1.77,1.77,0,0,0-.83-1.38L10.3,80.2c-.46-.27-.83-.08-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    className: "cls-9",
    d: "M10.3,80.2l5.39,3.11v1.8L10.3,82a1.79,1.79,0,0,1-.83-1.38c0-.5.37-.68.83-.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    className: "cls-8",
    d: "M8.74,86.49,27.31,97.21a1.84,1.84,0,0,1,.83,1.43v7.07c0,.53-.38.74-.83.48L8.74,95.47A1.83,1.83,0,0,1,7.91,94V87c0-.53.37-.75.83-.48",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    className: "cls-9",
    d: "M9.47,89.6A1.77,1.77,0,0,0,10.3,91L25.75,99.9c.46.26.83.08.83-.42a1.79,1.79,0,0,0-.83-1.38L10.3,89.18c-.46-.26-.83-.07-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    className: "cls-7",
    d: "M9.47,93.19a1.77,1.77,0,0,0,.83,1.38l15.45,8.92c.46.27.83.08.83-.42a1.77,1.77,0,0,0-.83-1.37L10.3,92.77c-.46-.26-.83-.07-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    className: "cls-9",
    d: "M10.3,92.77l8.5,4.91v1.8l-8.5-4.91a1.77,1.77,0,0,1-.83-1.38c0-.49.37-.68.83-.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    className: "cls-8",
    d: "M8.74,99.06l18.57,10.72a1.85,1.85,0,0,1,.83,1.43v7.07c0,.53-.38.74-.83.48L8.74,108a1.82,1.82,0,0,1-.83-1.43V99.54c0-.53.37-.74.83-.48",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    className: "cls-9",
    d: "M9.47,102.18a1.77,1.77,0,0,0,.83,1.37l15.45,8.92c.46.27.83.08.83-.42a1.77,1.77,0,0,0-.83-1.37L10.3,101.75c-.46-.26-.83-.07-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    className: "cls-7",
    d: "M9.47,105.77a1.77,1.77,0,0,0,.83,1.37l15.45,8.93c.46.26.83.07.83-.42a1.77,1.77,0,0,0-.83-1.38L10.3,105.35c-.46-.27-.83-.08-.83.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    className: "cls-9",
    d: "M10.3,105.35l11.61,6.7v1.8L10.3,107.14a1.77,1.77,0,0,1-.83-1.37c0-.5.37-.69.83-.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    className: "cls-6",
    d: "M35.13,60.42c.86-.5,1.56-.05,1.56,1v41.08a3.54,3.54,0,0,1-1.56,2.81c-.85.5-1.55.05-1.55-1V63.23a3.55,3.55,0,0,1,1.55-2.81",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    className: "cls-7",
    d: "M35.14,104.42a1.8,1.8,0,0,0,.77-1.41V61.82c0-.53-.34-.76-.77-.51a1.76,1.76,0,0,0-.78,1.4v41.2c0,.53.35.75.78.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    className: "cls-9",
    d: "M35.14,104.42a1.8,1.8,0,0,0,.77-1.41V83.31l-1.55.9v19.7c0,.52.35.75.78.5",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    className: "cls-6",
    d: "M39.8,57.72c.86-.5,1.56,0,1.56,1V99.81a3.56,3.56,0,0,1-1.56,2.82c-.86.5-1.55.05-1.55-1V60.54a3.59,3.59,0,0,1,1.55-2.82",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    className: "cls-9",
    d: "M39.8,101.72a1.77,1.77,0,0,0,.78-1.4V59.12c0-.53-.35-.76-.78-.51A1.78,1.78,0,0,0,39,60v41.19c0,.53.35.76.78.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    className: "cls-6",
    d: "M44.47,55c.86-.5,1.55-.05,1.55,1V97.12a3.59,3.59,0,0,1-1.55,2.82c-.86.5-1.56,0-1.56-1V57.84A3.55,3.55,0,0,1,44.47,55",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    className: "cls-7",
    d: "M44.47,99a1.78,1.78,0,0,0,.78-1.41V56.43c0-.53-.35-.76-.78-.51a1.77,1.77,0,0,0-.78,1.4v41.2c0,.53.35.76.78.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    className: "cls-9",
    d: "M44.47,99a1.78,1.78,0,0,0,.78-1.41V65.8l-1.56.9V98.52c0,.53.35.76.78.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    className: "cls-6",
    d: "M49.14,52.33c.85-.5,1.55,0,1.55,1V94.43a3.57,3.57,0,0,1-1.55,2.81c-.86.5-1.56.05-1.56-1V55.15a3.57,3.57,0,0,1,1.56-2.82",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    className: "cls-7",
    d: "M49.14,96.33a1.79,1.79,0,0,0,.77-1.4V53.73c0-.53-.34-.75-.77-.51a1.78,1.78,0,0,0-.78,1.41V95.82c0,.53.35.76.78.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    className: "cls-9",
    d: "M49.14,96.33a1.79,1.79,0,0,0,.77-1.4V88l-1.55.9v6.95c0,.53.35.76.78.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    className: "cls-6",
    d: "M53.8,49.64c.86-.5,1.56,0,1.56,1V91.73a3.57,3.57,0,0,1-1.56,2.82c-.86.5-1.55,0-1.55-1V52.46a3.57,3.57,0,0,1,1.55-2.82",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    className: "cls-7",
    d: "M53.8,93.64a1.78,1.78,0,0,0,.78-1.41V51c0-.53-.35-.76-.78-.51A1.78,1.78,0,0,0,53,51.94V93.13c0,.53.35.76.78.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    className: "cls-9",
    d: "M53.8,93.64a1.78,1.78,0,0,0,.78-1.41V70.74l-1.56.9V93.13c0,.53.35.76.78.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    className: "cls-6",
    d: "M34.24,110.32l20.45-11.8c.37-.22.67,0,.67.38v7.45a1.48,1.48,0,0,1-.67,1.15L34.24,119.3c-.36.22-.66,0-.66-.38v-7.45a1.47,1.47,0,0,1,.66-1.15",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    className: "cls-7",
    d: "M35.08,112.53c0,.5.38.69.84.42L53,103.07a1.77,1.77,0,0,0,.83-1.38c0-.49-.37-.68-.83-.42l-17.12,9.89a1.8,1.8,0,0,0-.83,1.37",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    className: "cls-9",
    d: "M35.08,112.53c0,.5.38.69.83.42l12.45-7.19V104l-12.45,7.19a1.8,1.8,0,0,0-.83,1.37",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    className: "cls-7",
    d: "M35.08,116.12c0,.5.38.69.84.42L53,106.66a1.77,1.77,0,0,0,.83-1.37c0-.5-.37-.69-.83-.42l-17.12,9.88a1.8,1.8,0,0,0-.83,1.37",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    className: "cls-9",
    d: "M35.08,116.12c0,.5.38.69.84.42l4.66-2.69v-1.8l-4.67,2.7a1.76,1.76,0,0,0-.82,1.37",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    className: "cls-8",
    d: "M56.86,40.62,32.08,26.31a1.86,1.86,0,0,0-1.66,0L5.63,40.62a.51.51,0,0,0-.31.65.5.5,0,0,0,.31.31L30.42,55.89a1.86,1.86,0,0,0,1.66,0L56.86,41.58a.5.5,0,0,0,.32-.64.53.53,0,0,0-.32-.32",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    className: "cls-7",
    d: "M30.75,52.49,11.52,41.39a1.11,1.11,0,0,1-.5-.86v-.65a1.11,1.11,0,0,1,.5-.86l19.23-11.1a1.08,1.08,0,0,1,1,0L51,39a1.08,1.08,0,0,1,.5.86v.65a1.08,1.08,0,0,1-.5.86L31.74,52.49a1.08,1.08,0,0,1-1,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    className: "cls-8",
    d: "M11.52,39.59,30.75,50.7a1.15,1.15,0,0,0,1,0L51,39.59A.3.3,0,0,0,51,39L31.75,28.3a1.1,1.1,0,0,0-1,0L11.52,39a.3.3,0,0,0,0,.57",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    className: "cls-6",
    d: "M31.25,50.81v1.8a1.06,1.06,0,0,1-.5-.12L11.52,41.39a1.11,1.11,0,0,1-.5-.86v-.65a1.14,1.14,0,0,1,.41-.8c-.18.16-.15.38.09.51l19.23,11.1a.86.86,0,0,0,.5.12",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    className: "cls-7",
    d: "M30.75,47.1l-13-7.51a1.07,1.07,0,0,1-.49-.86v-.64a1.08,1.08,0,0,1,.49-.87l8.34-4.81a3.17,3.17,0,0,0,.84-.75l4-5.36a.66.66,0,0,1,.84-.18l13,7.51a1.11,1.11,0,0,1,.5.86v4.24a1.11,1.11,0,0,1-.5.86l-13,7.51a1.08,1.08,0,0,1-1,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    className: "cls-8",
    d: "M31.74,45.31l8.34-4.82a2.94,2.94,0,0,0,.84-.75l4-5.36a.49.49,0,0,0-.08-.7l-.07,0-13-7.51a.67.67,0,0,0-.84.18l-4,5.36a3.17,3.17,0,0,1-.77.78l-8.41,4.78a.32.32,0,0,0-.19.39.3.3,0,0,0,.19.19l13,7.51a1.08,1.08,0,0,0,1,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    className: "cls-6",
    d: "M44.75,33.63l-13-7.51a.67.67,0,0,0-.84.18l-4,5.36a2.33,2.33,0,0,1-.41.42l14,8.09a2.72,2.72,0,0,0,.4-.43l4-5.36a.49.49,0,0,0-.08-.7l-.07,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    className: "cls-9",
    d: "M20.9,37.36a1.27,1.27,0,0,1,1.17,0,.36.36,0,0,1,.22.45.4.4,0,0,1-.22.22,1.27,1.27,0,0,1-1.17,0,.34.34,0,0,1-.22-.45.31.31,0,0,1,.22-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    className: "cls-9",
    d: "M23.23,38.7a1.34,1.34,0,0,1,1.17,0,.35.35,0,0,1,.22.45.36.36,0,0,1-.22.23,1.33,1.33,0,0,1-1.17,0,.37.37,0,0,1-.22-.45.36.36,0,0,1,.22-.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    className: "cls-7",
    d: "M25.57,40.05a1.25,1.25,0,0,1,1.16,0,.35.35,0,0,1,.23.45.34.34,0,0,1-.23.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.36.36,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    className: "cls-7",
    d: "M27.9,41.4a1.25,1.25,0,0,1,1.16,0,.35.35,0,0,1,.23.45.36.36,0,0,1-.23.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.34.34,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    className: "cls-9",
    d: "M22.65,36.35a1.27,1.27,0,0,1,1.17,0,.36.36,0,0,1,.22.45.4.4,0,0,1-.22.22,1.27,1.27,0,0,1-1.17,0,.35.35,0,0,1-.22-.45.31.31,0,0,1,.22-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    className: "cls-7",
    d: "M25,37.69a1.34,1.34,0,0,1,1.17,0,.35.35,0,0,1,.22.45.36.36,0,0,1-.22.23,1.34,1.34,0,0,1-1.17,0,.37.37,0,0,1-.22-.45.36.36,0,0,1,.22-.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    className: "cls-9",
    d: "M27.32,39a1.25,1.25,0,0,1,1.16,0,.35.35,0,0,1,.23.45.36.36,0,0,1-.23.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.36.36,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    className: "cls-7",
    d: "M29.65,40.39a1.27,1.27,0,0,1,1.17,0,.36.36,0,0,1,.22.45.4.4,0,0,1-.22.22,1.27,1.27,0,0,1-1.17,0,.34.34,0,0,1-.22-.45.31.31,0,0,1,.22-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    className: "cls-7",
    d: "M24.4,35.33a1.33,1.33,0,0,1,1.17,0,.37.37,0,0,1,.22.46.4.4,0,0,1-.22.22,1.34,1.34,0,0,1-1.17,0,.35.35,0,0,1-.22-.45.34.34,0,0,1,.22-.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    className: "cls-9",
    d: "M26.73,36.68a1.34,1.34,0,0,1,1.17,0,.35.35,0,0,1,.22.45.36.36,0,0,1-.22.23,1.33,1.33,0,0,1-1.17,0,.37.37,0,0,1-.22-.45.36.36,0,0,1,.22-.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    className: "cls-7",
    d: "M29.07,38a1.25,1.25,0,0,1,1.16,0,.34.34,0,0,1,.22.45.31.31,0,0,1-.22.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.36.36,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    className: "cls-9",
    d: "M30.25,42.72a1.25,1.25,0,0,1,1.16,0,.34.34,0,0,1,.22.45.32.32,0,0,1-.22.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.34.34,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    className: "cls-7",
    d: "M32,41.71a1.25,1.25,0,0,1,1.16,0,.35.35,0,0,1,.23.45.39.39,0,0,1-.23.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.34.34,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    className: "cls-7",
    d: "M31.4,39.38a1.27,1.27,0,0,1,1.17,0,.36.36,0,0,1,.22.45.37.37,0,0,1-.22.22,1.27,1.27,0,0,1-1.17,0,.35.35,0,0,1-.23-.45.36.36,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    className: "cls-9",
    d: "M26.15,34.33a1.27,1.27,0,0,1,1.17,0,.36.36,0,0,1,.22.45.4.4,0,0,1-.22.22,1.27,1.27,0,0,1-1.17,0,.34.34,0,0,1-.22-.45.31.31,0,0,1,.22-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    className: "cls-7",
    d: "M28.48,35.67a1.33,1.33,0,0,1,1.17,0,.36.36,0,0,1,0,.68,1.34,1.34,0,0,1-1.17,0,.37.37,0,0,1-.22-.45.36.36,0,0,1,.22-.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    className: "cls-9",
    d: "M30.82,37A1.25,1.25,0,0,1,32,37a.35.35,0,0,1,.23.45.36.36,0,0,1-.23.22,1.25,1.25,0,0,1-1.16,0,.35.35,0,0,1-.23-.45.36.36,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    className: "cls-7",
    d: "M33.15,38.37a1.27,1.27,0,0,1,1.17,0,.36.36,0,0,1,.22.45.4.4,0,0,1-.22.22,1.27,1.27,0,0,1-1.17,0,.35.35,0,0,1-.23-.45.34.34,0,0,1,.23-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    className: "cls-9",
    d: "M33.74,40.7a1.27,1.27,0,0,1,1.17,0,.35.35,0,0,1,.23.45.36.36,0,0,1-.23.22,1.27,1.27,0,0,1-1.17,0,.36.36,0,0,1-.22-.45.34.34,0,0,1,.22-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    className: "cls-7",
    d: "M35.49,39.69a1.27,1.27,0,0,1,1.17,0,.34.34,0,0,1,.22.45.32.32,0,0,1-.22.22,1.27,1.27,0,0,1-1.17,0,.36.36,0,0,1-.22-.45.34.34,0,0,1,.22-.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    className: "cls-6",
    d: "M31.27,45.43v1.79a1,1,0,0,1-.52-.12l-13-7.51a1.07,1.07,0,0,1-.49-.86v-.65a1.06,1.06,0,0,1,.4-.79c-.18.16-.15.37.09.51l13,7.51a1.17,1.17,0,0,0,.52.12",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    className: "cls-7",
    d: "M28.64,31.44v0a.44.44,0,0,1,.56-.11l11.32,6.53a.33.33,0,0,1,.13.45s0,0,0,.05h0a.45.45,0,0,1-.56.12L28.75,31.94a.33.33,0,0,1-.14-.45l0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    className: "cls-9",
    d: "M28.64,31.44v0a.44.44,0,0,1,.56-.11l8.42,4.85-.47.63-8.41-4.85a.33.33,0,0,1-.14-.45l0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    className: "cls-7",
    d: "M29.58,30.18h0a.44.44,0,0,1,.56-.12l11.32,6.53a.33.33,0,0,1,.13.45l0,0v0a.44.44,0,0,1-.56.11L29.68,30.68a.33.33,0,0,1-.13-.45s0,0,0-.05",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    className: "cls-9",
    d: "M29.58,30.18h0a.44.44,0,0,1,.56-.12L33,31.67l-.47.63-2.81-1.62a.33.33,0,0,1-.13-.45s0,0,0-.05",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    className: "cls-7",
    d: "M30.51,28.93v0a.44.44,0,0,1,.56-.11L42.4,35.33a.34.34,0,0,1,.14.45l0,0h0a.45.45,0,0,1-.56.12L30.62,29.43a.33.33,0,0,1-.14-.45l0-.05",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    className: "cls-9",
    d: "M30.51,28.93v0a.45.45,0,0,1,.56-.12l5.9,3.4-.47.63-5.89-3.39a.33.33,0,0,1-.14-.45l0-.05",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    className: "cls-7",
    d: "M31.45,27.67v0a.43.43,0,0,1,.56-.11l11.32,6.53a.33.33,0,0,1,.13.45l0,0v0a.44.44,0,0,1-.56.11L31.55,28.17a.33.33,0,0,1-.13-.45l0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    className: "cls-9",
    d: "M31.45,27.67v0a.43.43,0,0,1,.56-.11l10.27,5.93-.47.63L31.55,28.17a.33.33,0,0,1-.13-.45l0,0",
    transform: "translate(0 0)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    className: "cls-10",
    d: "M83.92,101v21a.53.53,0,0,0,.25.43l20.1,11.6a.55.55,0,0,0,.5,0l.67-.39a.55.55,0,0,0,.25-.43v-21a.29.29,0,0,0-.29-.29h0L84.21,100.72a.29.29,0,0,0-.29.29h0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    className: "cls-11",
    d: "M105.4,111.93h-.59a.29.29,0,0,0-.29.29h0v21.64c0,.16.11.23.25.15l.67-.39a.59.59,0,0,0,.25-.43v-21a.29.29,0,0,0-.29-.29h0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    className: "cls-4",
    d: "M124,77V98a.55.55,0,0,0,.25.43l20.9,12.06a.55.55,0,0,0,.5,0l.67-.39a.59.59,0,0,0,.25-.43v-21a.29.29,0,0,0-.29-.29h0l-22-11.67A.29.29,0,0,0,124,77h0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    className: "cls-12",
    d: "M146.23,88.36h-.6a.29.29,0,0,0-.28.29h0v21.64c0,.16.11.22.25.14l.67-.38a.59.59,0,0,0,.25-.43v-21a.29.29,0,0,0-.29-.29h0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    className: "cls-11",
    d: "M82,100.35v-.2a1.08,1.08,0,0,1,.5-.86L124.63,75a1.08,1.08,0,0,1,1,0L148,87.84a1.11,1.11,0,0,1,.5.86v.2a1.11,1.11,0,0,1-.5.86l-42.17,24.35a1.1,1.1,0,0,1-1,0l-22.34-12.9a1.07,1.07,0,0,1-.49-.86",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    className: "cls-12",
    d: "M105.29,112.89v1.34a1,1,0,0,1-.5-.12L82.45,101.22a1.07,1.07,0,0,1-.49-.86v-.2a1.09,1.09,0,0,1,.4-.8c-.18.15-.15.37.09.51l22.34,12.9a1.08,1.08,0,0,0,.5.12",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    className: "cls-10",
    d: "M82.45,99.87l22.34,12.89a1.1,1.1,0,0,0,1,0L148,88.42a.31.31,0,0,0,.19-.39.3.3,0,0,0-.19-.19L125.62,75a1.08,1.08,0,0,0-1,0L82.45,99.29a.31.31,0,0,0,0,.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    className: "cls-12",
    d: "M118.46,90.86l12.63-7.3a.91.91,0,0,1,.82,0l4,2.33a.26.26,0,0,1,.15.32.23.23,0,0,1-.15.15l-12.64,7.31a.89.89,0,0,1-.81,0l-4-2.34a.25.25,0,0,1-.16-.31.28.28,0,0,1,.16-.16",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    className: "cls-12",
    d: "M120.7,86.33h0l-1.33-.77a.2.2,0,0,1-.13-.26.2.2,0,0,1,.13-.12l10.49-6.06a.21.21,0,0,0,0-.39l-.11-.06a.76.76,0,0,0-.66,0l-10.2,5.89c-.18.11-.35.12-.36,0a1.09,1.09,0,0,1,0-.18l.58-3a.57.57,0,0,0-.26-.56l-.1-.06a.25.25,0,0,0-.36.06.26.26,0,0,0,0,.12l-.66,3.48a1,1,0,0,0,0,.38.55.55,0,0,1-.23.56l-6.36,3.68a.19.19,0,0,0-.13.25.21.21,0,0,0,.13.13l.1.06a.72.72,0,0,0,.67,0L117.92,86a1.19,1.19,0,0,1,.36-.17h0l2.07,1.2a.76.76,0,0,0,.66,0l4.33-2.5c.18-.1.24-.24.13-.3a.73.73,0,0,0-.54.06l-3.91,1.88-.35.16",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    className: "cls-6",
    d: "M131.85,82.59l3.78,2.18a.77.77,0,0,1,.32,1,.71.71,0,0,1-.32.32l-12.21,7.05a.91.91,0,0,1-.82,0L118.82,91a.77.77,0,0,1,0-1.36l12.21-7a.91.91,0,0,1,.82,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    className: "cls-7",
    d: "M123,93.28a.86.86,0,0,1-.41-.1L118.82,91a.77.77,0,0,1,0-1.36l.39-.22H123Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    className: "cls-8",
    d: "M118.81,89.64l12.22-7a.91.91,0,0,1,.82,0l3.78,2.18a.25.25,0,0,1,.15.32.26.26,0,0,1-.15.16l-12.22,7a.89.89,0,0,1-.81,0l-3.79-2.19a.23.23,0,0,1-.15-.31.24.24,0,0,1,.15-.16",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    className: "cls-9",
    d: "M130,85.84l.39-.22s0,0,0,0l-.44-.26a.06.06,0,0,0-.06,0l-.39.22a0,0,0,0,0,0,0l.44.25H130m-.76-.88-.38.22a0,0,0,0,0,0,0l.45.26h.06l.38-.23s0,0,0,0l-.45-.26h-.06m-1.24.72-.65.37a0,0,0,0,0,0,0l.44.25h.07l.65-.37a0,0,0,0,0,0,0l-.44-.25a.06.06,0,0,0-.06,0m.68-.39-.39.22s0,0,0,0l.44.26a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0l-.44-.25a.06.06,0,0,0-.06,0m-1.51.87-.39.22a0,0,0,0,0,0,0l.45.25a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0l-.44-.25h-.06m-.56.32-.39.22s0,0,0,0l.45.26a.06.06,0,0,0,.06,0l.38-.23s0,0,0,0l-.44-.26a.06.06,0,0,0-.06,0m1.75,1,.38-.23s0,0,0,0l-.44-.26a.06.06,0,0,0-.06,0l-.39.22a0,0,0,0,0,0,0l.45.26a.06.06,0,0,0,.06,0m-.56.32.38-.22a0,0,0,0,0,0,0l-.45-.25a.06.06,0,0,0-.06,0l-.38.22s0,0,0,0l.44.26a.09.09,0,0,0,.07,0m-.57.33.39-.23s0,0,0,0l-.45-.26h-.06l-.38.22a0,0,0,0,0,0,0l.44.26h.06m-.56.32.39-.22a0,0,0,0,0,0,0l-.44-.25h-.06l-.39.22s0,0,0,0l.44.26a.06.06,0,0,0,.06,0m2.77-2.33.38-.22a0,0,0,0,0,0,0l-.44-.26a.09.09,0,0,0-.07,0l-.38.23s0,0,0,0l.45.26a.06.06,0,0,0,.06,0m-.52,1,.86-.49a0,0,0,0,0,0,0l-1.08-.62h-.07l-.44.25a0,0,0,0,0,0,0l.57.33s0,0,0,0l-.35.21a0,0,0,0,0,0,0l.44.25h.07M126,86.81l-.38.22s0,0,0,0l.44.26a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0l-.45-.25a.06.06,0,0,0-.06,0m-.56.32-.39.22a0,0,0,0,0,0,0l.45.26h.06l.39-.23a0,0,0,0,0,0,0l-.45-.26h-.06m-2.81,3.64a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0l-.44-.25a.06.06,0,0,0-.06,0l-.39.22s0,0,0,0Zm-1.69-1-.38.22s0,0,0,0l.44.26a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0l-.45-.25a.06.06,0,0,0-.06,0m.91.76a.06.06,0,0,0,.06,0l.38-.22a0,0,0,0,0,0,0l-.44-.26a.06.06,0,0,0-.06,0l-.39.23a0,0,0,0,0,0,0Zm1.77.48.39-.22a0,0,0,0,0,0,0l-.44-.26a.06.06,0,0,0-.06,0l-.39.23s0,0,0,0l.44.26a.06.06,0,0,0,.06,0m-.62.32h.06l.38-.22a0,0,0,0,0,0,0l-.44-.25a.06.06,0,0,0-.06,0l-.39.22s0,0,0,0Zm-1.5-1.89-.38.23s0,0,0,0l.44.26a.06.06,0,0,0,.06,0l.39-.22s0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0m2.81-1.62L124,88a0,0,0,0,0,0,0l.44.26a.09.09,0,0,0,.07,0l.38-.22a0,0,0,0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0m-2.25,1.3-.38.22a0,0,0,0,0,0,0l.45.26h.06l.38-.23s0,0,0,0l-.44-.26a.09.09,0,0,0-.07,0m2.82-1.62-.39.22s0,0,0,0L125,88a.06.06,0,0,0,.06,0l.38-.22s0,0,0,0l-.44-.26h-.06m-1.12.64-.39.23a0,0,0,0,0,0,0l.45.26h.06l.38-.22a0,0,0,0,0,0,0l-.44-.26h-.06m-.56.33-.39.22s0,0,0,0l.45.25a.06.06,0,0,0,.06,0l.38-.22s0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0m-.56.32-.38.22a0,0,0,0,0,0,0l.44.26a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0m2.88.4.38-.22a0,0,0,0,0,0,0l-.45-.26h-.06l-.38.23s0,0,0,0l.44.26h.06m4.94-4.91-.38.23s0,0,0,0l.44.26h.07l.38-.22a0,0,0,0,0,0,0l-.45-.26h-.06m-.68.4-.38.22s0,0,0,0l.44.26h.07l.38-.22a0,0,0,0,0,0,0l-.45-.25a.06.06,0,0,0-.06,0m1.24-.72-.38.22s0,0,0,0l.45.25h.06l.38-.22a0,0,0,0,0,0,0l-.44-.25a.09.09,0,0,0-.07,0m-2.9,3,.38-.22a0,0,0,0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.38.23s0,0,0,0l.44.26a.09.09,0,0,0,.07,0m3.53-3.33a.06.06,0,0,0-.06,0l-.39.23s0,0,0,0l.45.26a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0Zm-5.56,5.23.38-.22s0,0,0,0l-.44-.26a.06.06,0,0,0-.06,0l-.39.22s0,0,0,0l.45.25a.06.06,0,0,0,.06,0m6.89-4,.39-.22a0,0,0,0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.38.22a0,0,0,0,0,0,0l.44.25H133m-1.2,0,.38-.22a0,0,0,0,0,0,0l-.45-.25a.06.06,0,0,0-.06,0l-.38.22s0,0,0,0l.45.25a.06.06,0,0,0,.06,0m.5-.84h-.06l-.39.22s0,0,0,0l.45.26h.06l.38-.23s0,0,0,0Zm.11-.07,1.09.63a.06.06,0,0,0,.06,0l.38-.22a0,0,0,0,0,0,0l-1.08-.62a.06.06,0,0,0-.06,0l-.39.22s0,0,0,0m-1.31.72-.38.22a0,0,0,0,0,0,0l.45.25h.06l.38-.22s0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0m-4.23,2.44-.38.23s0,0,0,0l.44.26a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0l-.45-.26h-.06m5.49-1.88a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.38.22a0,0,0,0,0,0,0Zm-4.93,1.56-.38.22a0,0,0,0,0,0,0l.44.25a.09.09,0,0,0,.07,0l.38-.22s0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0m-4.21,3.72h.06l.38-.23s0,0,0,0l-.44-.26a.06.06,0,0,0-.06,0l-.39.22s0,0,0,0Zm-.85-.8-.38.22a0,0,0,0,0,0,0l.44.25a.06.06,0,0,0,.06,0l.39-.22s0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0m1.47.47.39-.22s0,0,0,0l-.44-.26a.06.06,0,0,0-.06,0l-.39.22a0,0,0,0,0,0,0l.44.25h.06m.56-.32.39-.22s0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.38.23s0,0,0,0l.44.26a.06.06,0,0,0,.06,0m.57-.33.38-.22s0,0,0,0L124.9,89h-.06l-.38.22a0,0,0,0,0,0,0l.44.25a.09.09,0,0,0,.07,0m-2-.14-.38.22s0,0,0,0l.44.26h.07l.38-.22a0,0,0,0,0,0,0l-.45-.25a.06.06,0,0,0-.06,0m.57-.33-.39.22s0,0,0,0l.45.26h.06l.38-.23s0,0,0,0l-.44-.26a.09.09,0,0,0-.07,0m2.25-1.3-.38.22a0,0,0,0,0,0,0l.44.26a.06.06,0,0,0,.06,0l.39-.22s0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0m-.56.33-.38.22s0,0,0,0l.44.26h.06l.39-.22a0,0,0,0,0,0,0l-.45-.25a.06.06,0,0,0-.06,0m1.12-.65-.38.22s0,0,0,0l.45.25a.06.06,0,0,0,.06,0l.38-.22a0,0,0,0,0,0,0l-.44-.25h-.07m-2.24,1.3-.39.22a0,0,0,0,0,0,0l.45.26a.06.06,0,0,0,.06,0l.38-.22a0,0,0,0,0,0,0l-.44-.25a.06.06,0,0,0-.06,0m.56-.33-.39.22a0,0,0,0,0,0,0l.45.26h.06l.38-.23s0,0,0,0l-.44-.26h-.06m-.41,2.29.38-.22s0,0,0,0l-.44-.26h-.07l-.38.22a0,0,0,0,0,0,0l.45.25a.06.06,0,0,0,.06,0m-3.3-.33-.45-.26h-.06l-.38.23s0,0,0,0l.44.26a.06.06,0,0,0,.06,0l.39-.22s0,0,0,0m.84.25-.44-.26h-.06l-.6.34a0,0,0,0,0,0,0l.44.26h.06l.59-.35s0,0,0,0m-1.52-.75-.45-.25a.06.06,0,0,0-.06,0l-.47.27a0,0,0,0,0,0,0l.45.25h.06l.47-.27a0,0,0,0,0,0,0m.36-.2a.06.06,0,0,0,.06,0l.39-.23s0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.38.22a0,0,0,0,0,0,0Zm2,1.23-.45-.26a.06.06,0,0,0-.06,0l-.74.43a0,0,0,0,0,0,0l.44.25a.06.06,0,0,0,.06,0l.74-.42a0,0,0,0,0,0,0m.37.52-.45-.25a.06.06,0,0,0-.06,0l-.47.27s0,0,0,0l.44.26a.09.09,0,0,0,.07,0l.47-.27a0,0,0,0,0,0,0m1.86-4.17a.06.06,0,0,0,.06,0l.39-.22s0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.38.22a0,0,0,0,0,0,0Zm-1.12.65h.06l.39-.22s0,0,0,0l-.44-.25a.06.06,0,0,0-.06,0l-.39.22a0,0,0,0,0,0,0Zm-2.49,1.44a.06.06,0,0,0,.06,0l.38-.22a0,0,0,0,0,0,0l-.45-.25h-.06l-.38.22a0,0,0,0,0,0,0Zm3-1.76a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.39.23s0,0,0,0Zm-1.12.65a.06.06,0,0,0,.06,0l.38-.22a0,0,0,0,0,0,0l-.44-.26a.06.06,0,0,0-.06,0l-.39.23s0,0,0,0Zm.13,3.23a.06.06,0,0,0-.06,0l-.6.35s0,0,0,0L123,92h.06l.59-.34a0,0,0,0,0,0,0Zm-.94-2.77a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.39.22a0,0,0,0,0,0,0Zm-.56.33a.06.06,0,0,0,.06,0l.38-.22a0,0,0,0,0,0,0l-.44-.26h-.06l-.39.23s0,0,0,0Zm11.91-3.57a.06.06,0,0,0-.06,0l-.95.55s0,0,0,0l.44.26h.06l1-.55s0,0,0,0Zm-1.24.71h-.06l-.39.23s0,0,0,0l.45.26h.06l.38-.22a0,0,0,0,0,0,0Zm-7.62,4.22.39-.22a0,0,0,0,0,0,0l-.44-.26h-.06l-.39.23s0,0,0,0l.44.26a.06.06,0,0,0,.06,0m6.49-3.57a.06.06,0,0,0-.06,0l-.38.23s0,0,0,0l.44.26a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0Zm2.93-1.69a.06.06,0,0,0-.06,0l-.38.22a0,0,0,0,0,0,0l.44.26a.06.06,0,0,0,.06,0l.39-.23s0,0,0,0Zm1-.07-1.08-.62a.06.06,0,0,0-.06,0l-.39.22a0,0,0,0,0,0,0l1.08.62a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0m-6,3a.06.06,0,0,0-.06,0l-.48.27a0,0,0,0,0,0,0l.44.25a.06.06,0,0,0,.06,0l.48-.27a0,0,0,0,0,0,0Zm1.42-.82a.06.06,0,0,0-.06,0l-.59.34s0,0,0,0l.44.26a.09.09,0,0,0,.07,0l.59-.34a0,0,0,0,0,0,0Zm-2.72,1.57a.06.06,0,0,0-.06,0l-3.17,1.83s0,0,0,0l.45.26h.06L128.3,89s0,0,0,0Zm-3.35,1.93a.06.06,0,0,0-.06,0l-.47.27a0,0,0,0,0,0,0l.45.25a.06.06,0,0,0,.06,0l.47-.27s0,0,0,0Zm4-2.31a.06.06,0,0,0-.06,0l-.48.28a0,0,0,0,0,0,0l.45.26a.06.06,0,0,0,.06,0l.47-.27a0,0,0,0,0,0,0ZM123.87,91h-.07l-.47.28s0,0,0,0l.45.26h.06l.47-.27a0,0,0,0,0,0,0Zm5.94-3.43a.06.06,0,0,0-.06,0l-.47.27a0,0,0,0,0,0,0l.44.26a.09.09,0,0,0,.07,0l.47-.28s0,0,0,0Zm2-1.16a.06.06,0,0,0-.06,0l-.38.22a0,0,0,0,0,0,0l.45.25a.06.06,0,0,0,.06,0l.38-.22s0,0,0,0Zm1.24-.9.38-.22s0,0,0,0L133,85h-.07l-.38.22a0,0,0,0,0,0,0l.45.25a.06.06,0,0,0,.06,0m-2.52,0,.39-.22a0,0,0,0,0,0,0l-.44-.26a.06.06,0,0,0-.06,0l-.39.23s0,0,0,0l.44.26a.06.06,0,0,0,.06,0m-1.27,2.2,1.12-.65s0,0,0,0l-.44-.26a.09.09,0,0,0-.07,0l-1.12.65s0,0,0,0l.45.26a.06.06,0,0,0,.06,0m3.16-1.86a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.38.23s0,0,0,0Zm-.57-.37.38-.22s0,0,0,0L131.8,85a.06.06,0,0,0-.06,0l-.39.22a0,0,0,0,0,0,0l.45.25a.06.06,0,0,0,.06,0m-3.15,2.56.38-.23s0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.38.22a0,0,0,0,0,0,0l.45.26a.06.06,0,0,0,.06,0m2.48-1.47a.06.06,0,0,0,.06,0l.39-.23a0,0,0,0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.39.22a0,0,0,0,0,0,0Zm-5.29,3.09.38-.22a0,0,0,0,0,0,0l-.45-.26h-.06l-.38.23s0,0,0,0l.44.26a.09.09,0,0,0,.07,0m.56-.33.38-.22s0,0,0,0l-.44-.26a.09.09,0,0,0-.07,0l-.38.22a0,0,0,0,0,0,0l.45.25h.06m-1.12.65.38-.22s0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.38.22a0,0,0,0,0,0,0l.44.25a.09.09,0,0,0,.07,0m2.24-1.29.39-.23s0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.38.22a0,0,0,0,0,0,0l.44.26h.06M127,89l.39-.22a0,0,0,0,0,0,0l-.44-.25a.06.06,0,0,0-.06,0l-.39.22s0,0,0,0L127,89a.06.06,0,0,0,.06,0m1.13-.65.38-.22a0,0,0,0,0,0,0l-.45-.25a.06.06,0,0,0-.06,0l-.38.22s0,0,0,0l.45.26h.06m2.57-4.8a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0l-.12-.07H131l-.38.23s0,0,0,0ZM128,85.36a.06.06,0,0,0,.06,0l.39-.22s0,0,0,0l-.45-.26a.06.06,0,0,0-.06,0l-.38.22a0,0,0,0,0,0,0Zm1.13-.65a.06.06,0,0,0,.06,0l.38-.22a0,0,0,0,0,0,0l-.44-.26H129l-.39.23a0,0,0,0,0,0,0Zm-1.81,1a.06.06,0,0,0,.06,0l.38-.22s0,0,0,0l-.45-.26h-.06l-.38.22a0,0,0,0,0,0,0Zm1.24-.72a.09.09,0,0,0,.07,0l.38-.22s0,0,0,0l-.45-.26h-.06l-.38.22a0,0,0,0,0,0,0Zm-2.37,1.37h.06l.39-.22s0,0,0,0l-.44-.26a.06.06,0,0,0-.06,0l-.39.22a0,0,0,0,0,0,0Zm.56-.32a.06.06,0,0,0,.06,0l.39-.22s0,0,0,0l-.45-.25h-.06l-.38.22s0,0,0,0Zm2.89-1.86a.06.06,0,0,0,.06,0L130,84s0,0,0,0l-.12-.07a.06.06,0,0,0-.06,0l-.39.22a0,0,0,0,0,0,0Zm1.69-1a.06.06,0,0,0,.06,0l.39-.22a0,0,0,0,0,0,0l-.12-.07a.06.06,0,0,0-.06,0l-.38.23s0,0,0,0Zm.93.54h.06l.39-.22a0,0,0,0,0,0,0l-.45-.25a.06.06,0,0,0-.06,0l-.38.22s0,0,0,0Zm1.41,1.43L134,85s0,0,0,0l-.44-.26a.06.06,0,0,0-.06,0l-.39.22a0,0,0,0,0,0,0l.45.26a.06.06,0,0,0,.06,0m-3.46-1.32h.06l.38-.22a0,0,0,0,0,0,0l-.12-.07h-.06l-.39.23s0,0,0,0Zm-4.58,2.83h.06l.38-.22a0,0,0,0,0,0,0l-.44-.25a.06.06,0,0,0-.06,0l-.39.22s0,0,0,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    className: "cls-8",
    d: "M125.3,83.24l-4.59,2.65h0l-1.74-1a.93.93,0,0,1-.42-.93l.65-3.37,3.83-3.1.76.45-.65,3.37a.94.94,0,0,0,.43.92Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    className: "cls-7",
    d: "M120.71,85.89v.89l-2.4-1.39a1.41,1.41,0,0,1-.64-1.4l.74-3.85.77.44L118.52,84a1,1,0,0,0,.43.93l1.73,1Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    className: "cls-6",
    d: "M125.3,83.24l-4.59,2.65v.89l4.6-2.66Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    className: "cls-8",
    d: "M129.52,60.89a.84.84,0,0,1,.39.69v14.1a.92.92,0,0,1-.41.71L111.92,86.54a.76.76,0,0,1-1.06-.24.83.83,0,0,1-.12-.44V71.76a.92.92,0,0,1,.41-.71L128.73,60.9a.88.88,0,0,1,.79,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    className: "cls-7",
    d: "M111.92,86.54a.76.76,0,0,1-1.06-.24.82.82,0,0,1-.12-.43V71.76a.93.93,0,0,1,.12-.4l13.68,7.89Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    className: "cls-6",
    d: "M129.91,75.68V61.58c0-.26-.18-.37-.41-.24L111.92,71.49a.92.92,0,0,0-.41.71V86.31c0,.26.18.36.41.23L129.5,76.39a.92.92,0,0,0,.41-.71",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    className: "cls-13",
    d: "M128.91,62.13l-16.69,9.63a.74.74,0,0,0-.33.57V84.85c0,.21.15.29.33.19l16.69-9.63a.73.73,0,0,0,.32-.57V62.32c0-.21-.14-.29-.32-.19",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    className: "cls-7",
    d: "M105.58,107.82l-9.9-5.71a1.08,1.08,0,0,1-.5-.86v-6a1.08,1.08,0,0,1,.5-.86l6.78-3.92a1.17,1.17,0,0,1,1,0l9.89,5.72a1.11,1.11,0,0,1,.5.86v6a1.12,1.12,0,0,1-.5.87l-6.78,3.91a1.08,1.08,0,0,1-1,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    className: "cls-8",
    d: "M106.57,100.64l6.78-3.92a.3.3,0,0,0,0-.57l-9.9-5.71a1.08,1.08,0,0,0-1,0l-6.78,3.91a.29.29,0,0,0-.19.38.3.3,0,0,0,.19.19l9.89,5.72a1.1,1.1,0,0,0,1,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    className: "cls-6",
    d: "M106.07,100.76v7.18a1.11,1.11,0,0,1-.5-.12l-9.89-5.71a1.08,1.08,0,0,1-.5-.86v-6a1.11,1.11,0,0,1,.37-.76c-.14.15-.1.35.12.47l9.9,5.72a1.11,1.11,0,0,0,.5.12",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    className: "cls-6",
    d: "M98.15,94.72a.7.7,0,0,1,.66,0l7.11,4.1c.19.11.19.28,0,.38a.68.68,0,0,1-.65,0l-7.12-4.1c-.18-.11-.18-.28,0-.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    className: "cls-9",
    d: "M98.15,94.72a.7.7,0,0,1,.66,0l4.33,2.5-.64.38-4.34-2.51a.2.2,0,0,1,0-.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    className: "cls-6",
    d: "M99.39,94a.74.74,0,0,1,.65,0l7.12,4.11c.18.11.18.28,0,.38a.7.7,0,0,1-.66,0L99.4,94.38a.2.2,0,0,1,0-.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    className: "cls-9",
    d: "M99.39,94a.74.74,0,0,1,.65,0l.58.34-.64.37-.58-.33a.2.2,0,0,1,0-.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    className: "cls-6",
    d: "M100.62,93.29a.76.76,0,0,1,.66,0l7.11,4.11c.18.11.19.28,0,.38a.68.68,0,0,1-.65,0l-7.12-4.11a.2.2,0,0,1,0-.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    className: "cls-9",
    d: "M100.62,93.29a.76.76,0,0,1,.66,0l2.51,1.46-.64.37-2.52-1.45a.2.2,0,0,1,0-.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    className: "cls-6",
    d: "M101.86,92.58a.68.68,0,0,1,.65,0l7.11,4.11c.19.1.19.27,0,.38a.74.74,0,0,1-.65,0L101.87,93c-.19-.11-.19-.28,0-.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    className: "cls-9",
    d: "M101.86,92.58a.68.68,0,0,1,.65,0l5.09,2.94-.64.38L101.87,93c-.19-.11-.19-.28,0-.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    className: "cls-6",
    d: "M103.09,91.87a.68.68,0,0,1,.65,0l7.12,4.1c.18.11.19.28,0,.38a.7.7,0,0,1-.66,0l-7.11-4.1c-.18-.11-.19-.28,0-.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    className: "cls-9",
    d: "M103.09,91.87a.68.68,0,0,1,.65,0l6.41,3.69-.64.38-6.41-3.7a.2.2,0,0,1,0-.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    className: "cls-6",
    d: "M106.85,105.86v-1.23a1,1,0,0,1,.39-.8c.21-.12.39,0,.39.35v1.23a1,1,0,0,1-.39.8c-.22.12-.39,0-.39-.35",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    className: "cls-9",
    d: "M107.25,104a.56.56,0,0,0-.25.44c0,.17.11.24.25.15a.54.54,0,0,0,.26-.44c0-.17-.11-.23-.26-.15",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    className: "cls-6",
    d: "M108.07,105.15v-1.22a1,1,0,0,1,.39-.8c.22-.12.39,0,.39.35v1.22a1,1,0,0,1-.39.8c-.21.13-.39,0-.39-.35",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    className: "cls-9",
    d: "M108.46,104.72a.58.58,0,0,0-.25.45c0,.17.11.23.25.15a.56.56,0,0,0,.26-.45c0-.16-.11-.23-.26-.15",
    transform: "translate(0 0)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    className: "cls-7",
    d: "M131,120.26a4.92,4.92,0,0,1,.32,1.24,1.78,1.78,0,0,1-1.44,2.58,3.47,3.47,0,0,1-2.73-.53,10.82,10.82,0,0,0-3-1.64,6.75,6.75,0,0,1-2.66-1.21c-.75-.6-1.24-1.5.2-1.88s4,.21,6.86.33Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    className: "cls-14",
    d: "M131,118.49v2.12s-.29.71-1.5.75a1.84,1.84,0,0,1-1.61-.77v-2.1Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    className: "cls-6",
    d: "M127,104.61c0,2.64.74,14.81.74,14.81s1.08,1.37,3.42,0l.8-13.5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    className: "cls-7",
    d: "M124.63,124.41a4.92,4.92,0,0,1,.32,1.24,1.78,1.78,0,0,1-1.44,2.58,3.48,3.48,0,0,1-2.73-.53,10.82,10.82,0,0,0-3-1.64,6.83,6.83,0,0,1-2.66-1.21c-.75-.6-1.23-1.5.2-1.88s4,.21,6.86.33Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    className: "cls-14",
    d: "M124.63,122.64v2.12s-.29.71-1.5.75a1.81,1.81,0,0,1-1.6-.77v-2.1Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    className: "cls-6",
    d: "M120.58,108.76c0,2.64.74,14.81.74,14.81s1.08,1.36,3.43,0l.79-13.51Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    className: "cls-8",
    d: "M128.79,133.81a1.36,1.36,0,0,0,0,.29.66.66,0,0,0,.27.42h0a.8.8,0,0,0,.83-.07,2.53,2.53,0,0,0,1.13-2,.8.8,0,0,0-.32-.71h0l0,0h0a.72.72,0,0,0-.48,0,1.31,1.31,0,0,0-.27.12,2.49,2.49,0,0,0-1.13,2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    className: "cls-7",
    d: "M129.1,131.38a1,1,0,0,1,.5-.16.62.62,0,0,1,.32.09l0,0,.73.42a.75.75,0,0,0-.49,0l-.27.12a2.49,2.49,0,0,0-1.13,2,1.36,1.36,0,0,0,0,.29.66.66,0,0,0,.27.42l-.75-.43h0l-.07,0h0a.83.83,0,0,1-.27-.7,2.47,2.47,0,0,1,1.13-2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    className: "cls-8",
    d: "M141,127.23a1.36,1.36,0,0,0,0,.29.66.66,0,0,0,.27.42h0a.79.79,0,0,0,.82-.07,2.47,2.47,0,0,0,1.13-2,.82.82,0,0,0-.32-.71h0l-.05,0h0a.72.72,0,0,0-.48,0,1.39,1.39,0,0,0-.28.12,2.49,2.49,0,0,0-1.13,2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    className: "cls-7",
    d: "M141.33,124.8a1,1,0,0,1,.5-.15.62.62,0,0,1,.32.09h0l.73.42a.72.72,0,0,0-.48,0,1.39,1.39,0,0,0-.28.12,2.49,2.49,0,0,0-1.13,2,1.36,1.36,0,0,0,0,.29.66.66,0,0,0,.27.42l-.75-.43h0l-.07,0h0a.81.81,0,0,1-.27-.69,2.49,2.49,0,0,1,1.13-2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    className: "cls-8",
    d: "M138.84,136.38a1,1,0,0,1,0,.29.69.69,0,0,1-.26.42h0a.76.76,0,0,1-.82-.06,2.52,2.52,0,0,1-1.14-2,.83.83,0,0,1,.32-.72h0l.05,0h0a.72.72,0,0,1,.48,0,1.39,1.39,0,0,1,.28.12,2.54,2.54,0,0,1,1.13,2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    className: "cls-7",
    d: "M138.53,133.94a1.16,1.16,0,0,0-.51-.15.62.62,0,0,0-.32.09l0,0-.73.42a.66.66,0,0,1,.48,0,1.31,1.31,0,0,1,.27.12,2.51,2.51,0,0,1,1.14,2,1.55,1.55,0,0,1,0,.29.69.69,0,0,1-.26.42l.74-.44h0l.06,0h0a.85.85,0,0,0,.28-.7,2.52,2.52,0,0,0-1.13-2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    className: "cls-8",
    d: "M146.78,132.49a1.45,1.45,0,0,1,0,.29.69.69,0,0,1-.26.42h0a.76.76,0,0,1-.82-.06,2.51,2.51,0,0,1-1.14-2,.83.83,0,0,1,.32-.72h0l0,0h0a.72.72,0,0,1,.48,0,1.31,1.31,0,0,1,.27.12,2.52,2.52,0,0,1,1.14,2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    className: "cls-7",
    d: "M146.47,130.06a1.05,1.05,0,0,0-.51-.16.62.62,0,0,0-.32.09l0,0-.73.42a.72.72,0,0,1,.48,0,1.31,1.31,0,0,1,.27.12,2.47,2.47,0,0,1,1.13,2,1.36,1.36,0,0,1,0,.29.69.69,0,0,1-.26.42l.74-.44h0l.06,0h0a.84.84,0,0,0,.28-.7,2.52,2.52,0,0,0-1.13-1.95",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    className: "cls-8",
    d: "M131.43,127.72a1.36,1.36,0,0,1,0,.29.7.7,0,0,1-.27.42h0a.76.76,0,0,1-.82-.06,2.47,2.47,0,0,1-1.13-2,.76.76,0,0,1,.32-.71h0l.06,0h0a.72.72,0,0,1,.48,0,1.39,1.39,0,0,1,.28.12,2.49,2.49,0,0,1,1.13,2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    className: "cls-7",
    d: "M131.12,125.29a1,1,0,0,0-.5-.16.57.57,0,0,0-.32.09l0,0-.73.42a.72.72,0,0,1,.48,0,1.39,1.39,0,0,1,.28.12,2.53,2.53,0,0,1,1.13,2,1.36,1.36,0,0,1,0,.29.7.7,0,0,1-.27.42l.75-.44h0l.06,0h0a.84.84,0,0,0,.28-.7,2.47,2.47,0,0,0-1.13-1.95",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    className: "cls-11",
    d: "M138.18,125.33l4-1.16V125l-4,2.33Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    className: "cls-10",
    d: "M138.18,125.33l-.4-.25,4.05-1.1.38.19Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    className: "cls-11",
    d: "M136.43,127.9l-5.72-2.15v-.87l5.72.51Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    className: "cls-10",
    d: "M130.71,124.88l.42-.11,5.64.37-.34.25Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    className: "cls-10",
    d: "M136.28,127.62c0,.65,2,.65,2,0V122h-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    className: "cls-10",
    d: "M137.77,126.15l1.09,7.11h-.74l-1-7.11a1.31,1.31,0,0,0,.68,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    className: "cls-11",
    d: "M137.09,126.15v1.95l1,6.36v-1.2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    className: "cls-12",
    x: 138.12,
    y: 133.26,
    width: 0.75,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    className: "cls-11",
    d: "M136.75,128l-7.38,3.87v-1.19l7.38-4.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    className: "cls-10",
    d: "M136.75,126.16a.82.82,0,0,1-.47-.22l-7.37,4.47.46.31Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    className: "cls-12",
    d: "M129.37,131.91v-1.19l-.46-.31v1.16Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    className: "cls-11",
    d: "M146.06,130.55l-7.89-2.7v-1.77l7.89,3.28Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    className: "cls-10",
    d: "M138.17,126.08c.07,0,.09-.14.1-.31l8,3.49-.23.1Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    className: "cls-12",
    d: "M146.29,129.26v1.15l-.23.14v-1.19Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    className: "cls-3",
    d: "M139,112.11h-3.37v11.67c0,1,3.37,1,3.37,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    className: "cls-9",
    d: "M124.29,113.15h0a1.68,1.68,0,0,1,.85-1.46l11.79-6.8a1.63,1.63,0,0,1,1.68,0l11.79,6.8a1.69,1.69,0,0,1,.85,1.46l-13.48,7.78Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    className: "cls-10",
    d: "M124.29,113.15v1l12.65,7.3a1.69,1.69,0,0,0,1.66,0l12.65-7.3v-1l-12.65,7.3a1.64,1.64,0,0,1-1.66,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    className: "cls-11",
    d: "M124.29,113.15v1l12.65,7.3a1.72,1.72,0,0,0,.83.22v-1a1.62,1.62,0,0,1-.83-.23Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M124.29,113.15a1.76,1.76,0,0,1,.18-.75l12.74,7.36a1.1,1.1,0,0,0,1.11,0l12.75-7.35a1.72,1.72,0,0,1,.18.74l-13.48,7.78-13.48-7.78Z",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    className: "cls-7",
    d: "M147.17,107.84s-10.94-3.3-12.84-3.82-5.56-1.4-6.62-.92a2.52,2.52,0,0,0-1.7,2.57c0,.29,0,1.7,0,1.7a39.2,39.2,0,0,0,9.62,1.63,95.6,95.6,0,0,0,11.54-1.16",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    className: "cls-14",
    d: "M137.82,89.25l.72,3.92,4,.47L142,88.22Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    className: "cls-17",
    d: "M134.06,86.12s-.52,1.62-.36,1.72a2.88,2.88,0,0,0,.88,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    className: "cls-14",
    d: "M135.1,80.93c-.69.73-1.35,1.95-1.06,5,.32,3.39,1.33,4.29,1.76,4.49.63.3,2.8-.22,3.51-.74a8,8,0,0,0,3-4.26c.51-2.35-.14-5-1.85-5.56a5.89,5.89,0,0,0-5.33,1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    className: "cls-7",
    d: "M133.52,82.6a5.32,5.32,0,0,0,3.39,3.25s.12-1.31,1.21-1.33,1.46,1.34.92,2.27-1.22.72-1.22.72A3.22,3.22,0,0,0,139.26,90a3.44,3.44,0,0,0,3.06-.2c.66-.42,1.42-2.24,1.81-3.7.83-3.09.68-5.45-1.28-5.93a2.23,2.23,0,0,0-2.31-1.8c-2.66-.17-4.38,1.8-6.59,1.8-1.16,0-.9,1.53-.43,2.41",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    className: "cls-7",
    d: "M142.8,80.41l1.33-.57a.72.72,0,1,0-1.34.54v0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    className: "cls-6",
    d: "M147.14,106.53c0,2.1.2,4.29-.68,5.83a10.15,10.15,0,0,1-9.31,4c-2.92-.49-12.36-4.08-12.36-4.08s-4.18-1.55-4.2-2.65c0-.27,0-.55,0-.84.09-1.46.68-3,3.74-2.95,3.34.08,13.24,1.71,13.24,1.71Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    className: "cls-8",
    d: "M146.36,92.94a3.07,3.07,0,0,0-3.14-2c-2.56.48-5.37,1.31-6.11,1.53h0s.34,5.64-2.56,7.34l-.38,7.19A6.23,6.23,0,0,0,136,109.1a8.49,8.49,0,0,0,5.87,1.65,7.4,7.4,0,0,0,5.31-2.91s0-6.78-.15-9.82a21.15,21.15,0,0,0-.66-5.07",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    className: "cls-6",
    d: "M134.48,101.17a9.55,9.55,0,0,0,2-3.39,5.4,5.4,0,0,1-2.07,4.11Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    className: "cls-14",
    d: "M137.11,92.43c-1.58.48-2.54.56-4.29,3.25s-5.57,8-5.94,8.65a2.83,2.83,0,0,0-.3,2.77c.42.76,1.66.43,3.39-1.09a63.65,63.65,0,0,0,5-5.63,28.48,28.48,0,0,0,2.15-7.95",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    className: "cls-8",
    d: "M137.11,92.43a12.11,12.11,0,0,0-2.28.73,3.59,3.59,0,0,0-1.73,1.42c-1.22,2-3,4.91-3,4.91s-.3,2.52,2.76,3.4l1.62-1.76a8.72,8.72,0,0,0,1.62-2.41,10.48,10.48,0,0,0,1-6.28",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    className: "cls-14",
    d: "M127.11,107.48c-1.46-.18-4.74-4.67-5.83-6.09a9.8,9.8,0,0,0-3-2.82,3.91,3.91,0,0,1-2.11-3.11c-.25-1.6,1.24-2.62,2.46-1,.78,1,1.56,1.66,1.6,1.49s-.24-.88-.23-1.62.63-.3.82,0a12.93,12.93,0,0,1,.66,1.47c.31.8.18,1.61.56,2.15s5.47,5.43,5.47,5.43Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    className: "cls-9",
    d: "M151.9,93.69v15.07l-12,6.92V100.63Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M151.9,93.69v15.07l-12,6.92V100.63Z",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    className: "cls-9",
    d: "M138.86,115.06l1.08.62v-13.8c0-.66.2-1,.46-1.12.92-.57,2.12.63,2.12.63v-1l11.56-6.69c-1.09-.62-1.8-1-4,.21s-8.63,5-9.64,5.59a2.67,2.67,0,0,0-1.58,2.46v13.11",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    className: "cls-13",
    d: "M140.44,99.49c1-.65,7.45-4.35,9.64-5.59s2.91-.83,4-.21l-11.55,6.69a2.87,2.87,0,0,0-2.08-.89",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    className: "cls-9",
    d: "M142.52,101.39l11.56-6.72v-1l-11.56,6.69Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M142.52,101.39l11.56-6.72v-1l-11.56,6.69Z",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    className: "cls-23",
    d: "M142.69,120.48a1.06,1.06,0,0,0,1.05-1v-7.9a.53.53,0,0,0-.55-.52.54.54,0,0,0-.52.52v7.86l-.85-.49a.53.53,0,0,0-.73.19.54.54,0,0,0,.19.73l.89.51a1,1,0,0,0,.52.15",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    className: "cls-23",
    d: "M149.23,116.67a1,1,0,0,0,1.05-1v-7.9a.54.54,0,1,0-1.07,0v7.86l-.85-.49a.55.55,0,0,0-.74.19.54.54,0,0,0,.2.73h0l.89.52a1.07,1.07,0,0,0,.52.14",
    transform: "translate(0 0)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    className: "cls-25",
    x: 41.12,
    y: 29.89,
    width: 61.05,
    height: 61.12,
    transform: "translate(-21.84 67.34) rotate(-44.37)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    className: "cls-13",
    d: "M70.24,81A.42.42,0,0,1,70,81c-7-4.48-11.58-9.84-14-16.38-2.14-5.85-2.24-11.8-2.33-17l0-.7a.44.44,0,0,1,.44-.44h0a25.3,25.3,0,0,0,15.65-6.2.42.42,0,0,1,.52,0c5.26,3.49,12.75,4.5,16.76,4.8a.41.41,0,0,1,.39.39c.93,10.61-1.27,19.58-6.55,26.66a31.46,31.46,0,0,1-10.45,9,.46.46,0,0,1-.2,0m.12-.21,0,.08,0-.08a31.19,31.19,0,0,0,10.38-8.93c5.26-7,7.45-16,6.53-26.54a.26.26,0,0,0-.24-.23c-4-.3-11.54-1.32-16.83-4.82a.24.24,0,0,0-.31,0,25.48,25.48,0,0,1-15.76,6.25.26.26,0,0,0-.19.07.23.23,0,0,0-.07.19v.7c.09,5.23.19,11.17,2.32,17C58.58,71,63.12,76.34,70.1,80.8a.27.27,0,0,0,.26,0",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    className: "cls-13",
    d: "M76.63,55h-.82a.75.75,0,0,1-.75-.74V51.43a1.83,1.83,0,0,0-1.83-1.83H68.1a1.83,1.83,0,0,0-1.83,1.83v2.83a.74.74,0,0,1-.74.74H64.7a.74.74,0,0,1-.74-.74V51.43a4.14,4.14,0,0,1,4.14-4.15h5.13a4.15,4.15,0,0,1,4.15,4.15h0v2.83a.74.74,0,0,1-.75.74h0",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    className: "cls-13",
    d: "M77.66,55.67h-14a1.55,1.55,0,0,0-1.55,1.55h0V68a1.56,1.56,0,0,0,1.55,1.55h14A1.55,1.55,0,0,0,79.21,68h0V57.22a1.54,1.54,0,0,0-1.55-1.55h0M72.67,66a.59.59,0,0,1-.43.7h-3a.57.57,0,0,1-.57-.57.68.68,0,0,1,0-.14l.67-2.8a2.59,2.59,0,1,1,2.65,0Z",
    transform: "translate(0 0)"
  }))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityAndInfra);
export default __webpack_public_path__ + "static/media/security-and-infra.662175e46cc939335c023503564f14ad.svg";
export { ForwardRef as ReactComponent };